export default __webpack_public_path__ + "static/media/my_current-location-black.6eff5b23.svg";